/*
 * @Author: Merlin
 * @Date: 2024-02-19 15:27:15
 * @LastEditors: Merlin
 * @LastEditTime: 2024-02-19 15:33:39
 * @Description: 
 */
import step01 from '../img/rule01.png';
import step02 from '../img/rule02.png';
import mobile_step01 from '../img/mobile-rule01.png';
import mobile_step02 from '../img/mobile-rule02.png';

export const aKenoRule = [{
    content1: 'keno.ruleDesc01',
    constent2: '',
    img: step01,
    imgMobile: mobile_step01,
},{
    content1: 'keno.ruleDesc02',
    constent2: '',
    img: step02,
    imgMobile: mobile_step02,
},];


